<template>
	<div>
		<div class="fs5 lh125 fw5 c1 mb2 fw7">{{ $t("rejection_info") }}</div>
		<j-card class="flex-wrap xs-12 xs-right bg4--l3 p2 c1">
			<div class="fw7 fs3 c1 mb2">{{ `${$t("reasons")}:` }}</div>
			<ul class="pl6">
				<li class="mb1 fs3 lh125" v-for="(item, i) in codes" :key="i">
					{{ `${item.code} - ${item.name}` }}
				</li>
			</ul>
			<div class="xs-12 fw7 fs3 c1 mt4 lh125">
				{{ `${$t("remarks")}:` }}
			</div>
			<p class="xs-12 fs3 lh125">{{ remarks }}</p>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
export default {
	props: {
		codes: Array,
		remarks: String
	},
	components: {
		JCard
	}
}
</script>

